module.exports = __webpack_public_path__ + "img/cv-uparrow.3a65e4ca.svg";